<div *ngIf="loadingService.loading$ | async" class="loader">
  <div class="spinner"></div>
</div>
<!--<mat-progress-bar *ngIf="loadingService.loading$ | async" mode="indeterminate" style="width:inherit;position:absolute">

</mat-progress-bar>-->
